import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useAutoArchive = () => {
  const { toast } = useToast();

  const triggerAutoArchive = useCallback(async () => {
    try {
      // L'archivage est réservé aux administrateurs connectés :
      // sans session, l'edge function renvoie 401.
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        return null;
      }

      console.log('🔄 Déclenchement de l\'archivage automatique...');
      
      
      const { data, error } = await supabase.functions.invoke('archive-events', {
        body: { 
          autoArchive: true,
          force: false 
        }
      });

      if (error) {
        console.error('❌ Erreur lors de l\'archivage automatique:', error);
        throw error;
      }

      console.log('✅ Archivage automatique terminé:', data);
      
      if (data?.archivedEventsCount > 0) {
        toast({
          title: "Archivage automatique",
          description: `${data.archivedEventsCount} évènement(s) archivé(s) automatiquement.`,
        });
      }

      return data;
    } catch (error: any) {
      console.error('❌ Erreur dans l\'archivage automatique:', error);
      toast({
        title: "Erreur d'archivage",
        description: "Une erreur s'est produite lors de l'archivage automatique.",
        variant: "destructive",
      });
      throw error;
    }
  }, [toast]);

  const scheduleAutoArchive = useCallback(() => {
    // Exécuter l'archivage automatique quotidiennement à minuit
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    
    const timeUntilMidnight = tomorrow.getTime() - now.getTime();
    
    console.log(`⏰ Archivage automatique programmé dans ${Math.round(timeUntilMidnight / 1000 / 60 / 60)} heures`);
    
    setTimeout(() => {
      triggerAutoArchive();
      // Programmer le prochain archivage dans 24h
      const interval = setInterval(triggerAutoArchive, 24 * 60 * 60 * 1000);
      
      // Nettoyer l'intervalle au démontage du composant
      return () => clearInterval(interval);
    }, timeUntilMidnight);
  }, [triggerAutoArchive]);

  return {
    triggerAutoArchive,
    scheduleAutoArchive
  };
};